import React from 'react';
import { ReactComponent as FilterIcon } from '../../../../assets/images/icon-filter.svg';
import { useStyles } from '../styles';

interface IListFilterButton {
    title: string;
    onClick: () => void;
    selectedFilterCount: number;
}

export function ListFilterButton({ title, onClick, selectedFilterCount }: IListFilterButton) {
    const classes = useStyles();
    return (
        <div
            onClick={onClick}
            data-component-name="FILTER_BUTTON"
            className={`${selectedFilterCount > 0 ? classes.aplliedFilters : undefined} ${classes.filterBtn}`}
        >
            <FilterIcon />
            <p>
                {title} {selectedFilterCount > 0 && <span>({selectedFilterCount})</span>}
            </p>
        </div>
    );
}
